var _desc;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCropOlivo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "agrismart-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), /*#__PURE__*/React.createElement("g", {
    id: "agrismart-icon",
    transform: "scale(.34783)",
    style: {
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "m69 34.5c0 19.022-15.478 34.5-34.5 34.5s-34.5-15.478-34.5-34.5 15.478-34.5 34.5-34.5 34.5 15.478 34.5 34.5z",
    style: {
      clipRule: "evenodd",
      fill: "#009846",
      imageRendering: "optimizeQuality",
      shapeRendering: "geometricPrecision",
      strokeWidth: 0.11815
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.11815 0 0 .11815 -610.96 -1286)",
    style: {
      clipRule: "evenodd",
      fillRule: "evenodd",
      imageRendering: "optimizeQuality",
      shapeRendering: "geometricPrecision"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "m5391 11198-9-12c33-24 135-96 265-71l8 24c-130-25-232 35-264 59z",
    style: {
      fillRule: "nonzero",
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "m5504 11177c7-9 15-15 25-20 2-1 4-2 7-3-1-4-3-7-4-11-2-5-4-10-6-16l-17 5c1 5-1 25-4 44z",
    style: {
      fillRule: "nonzero",
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "m5420 11176c-39 25-69 51-91 65 11-9 46-42 85-72-63-7-149 111-160 133 33-11 157-70 166-126z",
    style: {
      fillRule: "nonzero",
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "m5463 11143c-46-1-85-7-111-7 14 2 61 12 110 16-50 39-185-16-206-29 34-8 170-23 207 19z",
    style: {
      fillRule: "nonzero",
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "m5531 11121c-43-16-78-34-103-43 13 6 54 31 99 51-60 21-170-75-185-94 35 3 168 34 190 86z",
    style: {
      fillRule: "nonzero",
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "m5601 11112c-39-25-69-50-91-64 11 9 46 42 85 71-63 8-150-110-161-132 33 11 157 69 167 124z",
    style: {
      fillRule: "nonzero",
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "m5503 11278c-17-38-16-68-7-88-20-3-44 7-70 32-38 39-40 75-19 96s58 19 96-20l7-7c-2-4-5-9-7-14z",
    style: {
      fillRule: "nonzero",
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "m5486 11211c5 6 2 16-10 25s-22 9-27 2c-5-6-2-16 10-25s22-9 27-2z",
    style: {
      fillRule: "nonzero",
      fill: "#009846"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "m5603 11323c-27 12-61-3-83-52-22-50-11-85 16-97s61 3 83 52c22 50 11 85-16 97z",
    style: {
      fillRule: "nonzero",
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "m5608 11286c-7 2-16-3-20-18s0-24 7-26 16 3 20 18 0 24-7 26z",
    style: {
      fillRule: "nonzero",
      fill: "#009846"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCropOlivo);
export default __webpack_public_path__ + "static/media/crop-olivo.d4ee62564b02bb0d081c210f167e37ac.svg";
export { ForwardRef as ReactComponent };